/** @jsxImportSource @emotion/react */
import { css, SerializedStyles } from "@emotion/react";
import { GitHubIcon } from "components/atoms/GitHubIcon/GitHubIcon";
import React from "react";
import { mixin } from "styles/mixin";
import { Button } from "../Button/Button";

type Props = {
  className?: string;
  cssOverride?: SerializedStyles;
  color?: string;
};

export const GitHubButton: React.FC<Props> = ({
  className,
  cssOverride,
  color = "#ffffff",
}) => {
  return (
    <Button
      cssOverride={css`
        ${cssOverride};
        width: fit-content;
      `}
      className={"" + (className ? ` ${className}` : "")}
    >
      <GitHubIcon
        cssOverride={css`
          display: flex;
          align-items: center;
          margin-right: 0.5rem;
        `}
        color={color}
        size={18}
      />
      <div
        css={css`
          ${mixin.text.description};
          color: ${color};
        `}
      >
        GitHub
      </div>
    </Button>
  );
};
